// extracted by mini-css-extract-plugin
export default {"sidebarItems":"SidebarContent_sidebarItems__zZGDf","active":"SidebarContent_active__2xRJg","exitButton":"SidebarContent_exitButton__lusFv"};